%YAML 1.1
%TAG !u! tag:unity3d.com,2011:
--- !u!114 &11400000
MonoBehaviour:
  m_ObjectHideFlags: 0
  m_CorrespondingSourceObject: {fileID: 0}
  m_PrefabInstance: {fileID: 0}
  m_PrefabAsset: {fileID: 0}
  m_GameObject: {fileID: 0}
  m_Enabled: 1
  m_EditorHideFlags: 0
  m_Script: {fileID: 11500000, guid: f1565e2ac6d6cbe4bb0b302c1b554d10, type: 3}
  m_Name: LongDraw
  m_EditorClassIdentifier: 
  impactPrefab: {fileID: 0}
  handGlowPrefab: {fileID: 0}
  handGlowScale: 0.2
  castAuraPrefab: {fileID: 7489370104637420957, guid: b537e8a82d547164c80ff39158b0c623,
    type: 3}
  castAuraScale: 0.4
  castAuraYOffset: 0.5
  attachCastAuraToCaster: 0
  castSound: {fileID: 8300000, guid: b49169f973e2c674caf89289d6b096a1, type: 3}
  castSoundVolume: 1
  soundBeforeChannel: {fileID: 0}
  beforeChannelSoundDelay: 0
  soundAfterChannel: {fileID: 0}
  afterChannelSoundDelay: 0
  animation: 0
  animationVariation: 259
  castDelay: 0
  animationSpeed: 1
  animationDuration: 1.1
  skipCooldownOnChannel: 0
  spellName: Long Draw
  description: "Deal <b>29</b> damage to the target. Reduce the healing received
    by the target by <b>25%</b> for <b>6</b> seconds. \n\nIf the target is poisoned,
    this will deal <b>38</b> damage instead. \n\nIf the target is within <b>10</b>
    yards, this will deal <b>50%</b> less damage."
  icon: {fileID: 2800000, guid: 78d18975f4524354199d2100476e9758, type: 3}
  usableBy: 060000000f000000
  cooldown: 6
  castTime: 1
  isCastInterruptible: 1
  channelTime: 0
  isOnGlobalCooldown: 1
  aoeRadius: 0
  isHidden: 0
  isInternal: 0
  isRegional: 0
  preventManualCasts: 0
  useKeyboardForFacing: 0
  spellType: {fileID: 11400000, guid: cac5c20beb8c65d47b88d3b03bc2946d, type: 2}
